import { useState, useEffect } from 'react';

import CopyButton from '../widgets/CopyButton';

function AuthMdCmd(props) {
  const [authorizeData, setAuthorizeData] = useState({});
  const [authURL, setAuthURL] = useState('');

  const cmdData = props.cmdData;
  cmdData.displayCmdData = (data) => {
    setAuthorizeData(data);
  };

  useEffect(() => {
    setAuthURL(authorizeData.wellKnownUri);
  }, [authorizeData]);

  // Authorization Server Metadata
  const mdData = 
  <div>
    <div id="generatedCmd" className="main-form-output white-text">
      <span className="code-line light-blue-text spc-pb-15">{authorizeData.wellKnownUri}</span>
    </div>
    <CopyButton data={authURL}></CopyButton>
  </div>

  if (authorizeData.wellKnownUri) {  
    return (    
      <div className="card card-body code-block">
        {mdData}    
       </div>
    );
  }

  return <div></div>
}

export default AuthMdCmd;
